<template lang='pug'>
div
    v-container(fluid, grid-list-xl)
      v-layout(row, wrap)
        v-flex(xs12)
          v-btn(@click="newGestationInteraction(currentGestation.iuid)", color="success", outline, large, v-if="gestationsItems.length > 0 && [roleTypes.admin, roleTypes.manager, roleTypes.doctor].includes(user.role)") {{ $t('messages.newStudy') }} (Criado em {{ currentGestation.date | formatDate }})
          v-btn(@click="newGestationAndInteraction", color="success", outline, large, v-if="[roleTypes.admin, roleTypes.manager, roleTypes.doctor].includes(user.role)") {{ $t('messages.newGestation') }}
        v-flex(xs12 sm8 v-if='listGiWhithoutGestation && listGiWhithoutGestation.length > 0')
          .subheading.pb-3
            v-icon.pr-3(color='warning') warning
            | Exames não vinculados
          template(v-for='(item, index) in listGiWhithoutGestation')
            v-card(v-bind:key='item.iuid' v-show="expand || index === 0")
              v-card-text
                .subheading.pb-2 Procedimentos
                ul.pl-5
                  li(v-for="group in groupBy(item.studies, ['date', 'room', 'resource', 'studyDate'])" :key='group.key')
                    | {{ item.studyDate? item.studyDate : (group.headers.date ? group.headers.date.toDate() : null) | formatDate }} - {{ group.headers.room }} - {{ group.headers.resource }}
                    ul
                      li(v-for="study in group.items")
                        v-icon(small v-if='study.hasImage') image
                        | {{ study.accessionNumber }} - {{ study.title }}
              v-card-actions
                v-tooltip(bottom)
                  template(v-slot:activator="{ on }")
                    v-btn(
                      small
                      flat
                      v-if="currentGestation"
                      v-on="on"
                      color='primary'
                      @click='addGiInLastGestation(item)') {{ $t('messages.newStudy') }} (Criado em {{ currentGestation.date | formatDate }})
                  span Incluir o exame na gestação atual
                v-tooltip(bottom)
                  template(v-slot:activator="{ on }")
                    v-btn(
                      small
                      flat
                      v-on="on"
                      color='primary darken-2'
                      @click='addGiInNewGestation(item)') {{ $t('messages.newGestation') }}
                  span Iniciar o exame em uma nova gestação
                v-spacer
                v-tooltip(bottom)
                  template(v-slot:activator="{ on }")
                    v-btn(
                      v-if="[roleTypes.admin,roleTypes.manager].indexOf(user.role) > -1"
                      icon
                      @click="deleteGestationInteraction(item.iuid, false)")
                      v-icon(color='error', small) fas fa-trash
            br(v-show="expand || index === 0")
          v-btn(@click="expand = !expand", color="success", outline, large v-show="listGiWhithoutGestation.length > 1") Mostrar Todos ({{listGiWhithoutGestation.length}})
        v-flex(xs12)
          v-timeline(dense)
            template(v-for='(gestation,index) in gestationsItems')
              transition-group(v-show="showCases[index]")
                v-timeline-item(v-for='(gestationInteraction, indexGI) in gestation.interactions' :key='gestationInteraction.iuid', color='warning lighten-1', fill-dot, small, right)
                  v-layout(row, wrap)
                    v-flex(sm2 style="align-items: center; display: flex;")
                      strong.subheading {{ gestationInteraction.studyDate? gestationInteraction.studyDate : gestationInteraction.date | formatDateExtend }}
                    v-flex(sm10)
                      v-card(max-width="550px")
                        v-card-title
                          .subheading.font-weight-light
                            | {{ gestationInteraction.forms ? gestationInteraction.forms['gestationalAge.info.calculada'] : '' | weeksAndDays }}
                          v-spacer
                          v-btn(@click="resend(gestationInteraction)", outline, small, style="margin-top: 0px;",  v-show="gestationInteraction.status === 'ERRO'") Reenviar
                          uf-report-status(:status='gestationInteraction.status')
                        v-card-text(style="padding: 0px")
                          ul
                            h4 Formulários
                          ul.pl-5
                            li(v-for="(form, formIndex) in getFormsList(gestationInteraction.forms)" :key="`form${formIndex}`") {{ form | capitalize }}
                          div(v-if="gestationInteraction.studies")
                            ul
                              h4 Exames
                            ul.pl-5
                              li(v-for="group in groupBy(gestationInteraction.studies, ['date', 'room', 'resource'])" :key='group.key')
                                | {{ group.headers.room }} - {{ group.headers.resource }}
                                ul
                                  li(v-for="study in group.items" :title="study.publish" :class="{'green--text': study.publish === 'OK', 'red--text': study.publish && study.publish !== 'OK'}")
                                    v-icon(small v-if='study.hasImage') image
                                    | {{ study.accessionNumber }} - {{ study.title }}
                          div(v-if="gestationInteraction.observations")
                            br
                            ul
                              h4 Observações do Atendimento
                              div(v-html="gestationInteraction.observations")
                          div(v-if="gestationInteraction.forms && gestationInteraction.forms['conclusion.info.text']")
                            ul
                              h4 Laudo
                              div(v-html="gestationInteraction.forms['conclusion.info.text']")
                        v-card-actions
                          v-list-tile.grow
                            v-list-tile-avatar(color='grey darken-3' size="35")
                              v-img.elevation-6(src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWc9kZq9EbswA20E-IX3nFwJuQeeCogLqUFyamUuw_DMtVUtmD')
                            v-list-tile-content
                              v-list-tile-title(v-if="gestationInteraction.doctor") Dr. {{ getDoctorName(gestationInteraction) }}
                              v-list-tile-title(v-else) {{ $t('messages.noDoctor') }}
                            v-layout.ma-auto(align-center, justify-end) {{ gestationInteraction.reportStatus }}
                              v-btn(
                                v-if="gestationInteraction.status === 'PUBLICADO'"
                                icon
                                @click="openReport(gestationInteraction.iuid)")
                                v-icon(color="primary", small) fas fa-eye
                              v-btn(icon :to='"/viewer/" + gestationInteraction.iuid' target="_blank")
                                v-icon(color="primary", small) fas fa-images
                              v-btn(
                                v-if="[roleTypes.admin, roleTypes.manager].includes(user.role) || (roleTypes.doctor === user.role && (!gestationInteraction.doctor || gestationInteraction.doctor.id === user.uid))"
                                icon
                                @click="openGestationInteraction(gestationInteraction)")
                                v-icon(color="primary", small) fas fa-folder-open
                              v-btn(
                                v-if="[roleTypes.admin, roleTypes.manager].includes(user.role) || (roleTypes.doctor === user.role && (!gestationInteraction.doctor || gestationInteraction.doctor.id === user.uid))"
                                icon
                                @click="deleteGestationInteraction(gestationInteraction.iuid, index)")
                                v-icon(color='error', small) fas fa-trash
              v-timeline-item(:key='gestation.iuid', color='primary lighten-1', fill-dot, large, right, @click.native.stop='openCase(index)')
                template(v-slot:icon='')
                  strong.white--text {{ gestation.date | formatDateMonth }}
                v-layout.pt-3(row, wrap)
                  v-flex(sm2)
                    strong.subheading {{ gestation.date | formatDateExtend }}
                  v-flex.text-xs-right(xs1)
                    v-tooltip(bottom)
                      template(v-slot:activator="{ on }")
                        v-icon.text-xs-left.pt-1(v-on="on" color='black',small v-show="!showCases[index]") fas fa-angle-down
                      span Mostrar Caso
                    v-tooltip(bottom)
                      template(v-slot:activator="{ on }")
                        v-icon.text-xs-left.pt-1(v-on="on" color='black',small v-show="showCases[index]") fas fa-angle-up
                      span Ocultar Caso
                  v-flex(sm2)
                    strong.subheading {{ $t('messages.startOfEvaluation') | capitalize }}
                  v-flex.text-xs-right.pt-1(xs1)
                    v-btn.mt-0(v-if="canDeleteGestation" icon @click.stop.prevent="deleteGestation(gestation.iuid)")
                      v-icon(color='error', small) fas fa-trash
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

import { core, db } from '@/store/firebase'
import apiGestation from '@/api/gestation'
import roleTypes from '@/utils/roleTypes'
import reportStatusType from '@/utils/reportStatusType'
import firestoreUtil from '@/utils/firestore'
import ufReportStatus from '@/components/ultra-fetal/reportStatus'
import api from '@/utils/api'

const URL_BASE_REPORT = 'https://report-server-dot-ultracarebr.appspot.com/report/'
export default {
  name: 'Gestations',

  components: {
    ufReportStatus
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
      patient: (state) => state.ultraFetal.patient,
      company: (state) => state.ultraFetal.company
    }),
    gestationsItems () {
      let items = []
      let showCases = []
      this.gestations.forEach(gestation => {
        gestation.interactions = this.gestationInteractions[gestation.iuid] || []
        items.push(gestation)
        showCases.push(true)
      })
      this.showCases = showCases
      return items
    },
    currentGestation () {
      if (this.gestationsItems.length === 0) return null
      return this.gestationsItems[0]
    },
    canDeleteGestation () {
      return [roleTypes.admin, roleTypes.manager].includes(this.user.role)
    }
  },

  data () {
    return {
      gestations: [],
      expand: false,
      showCases: [],
      gestationInteractions: {},
      listGiWhithoutGestation: [],
      roleTypes,
      unsubscribeGIwhitoutGestation: null
    }
  },

  mounted () {
    this.$store.dispatch('ultraFetal/getGestationInteraction', null)
    this.getGestation()
    this.getGIwhitoutGestation()
  },

  beforeDestroy () {
    if (this.unsubscribeGIwhitoutGestation) this.unsubscribeGIwhitoutGestation()
  },

  methods: {
    getDoctorName (gestationInteraction) {
      if (gestationInteraction.doctorName) {
        return gestationInteraction.doctorName
      }

      if (gestationInteraction.doctor && gestationInteraction.doctor.name) {
        return gestationInteraction.doctor.name
      }

      return this.$t('messages.unamed')
    },
    async getGestation () {
      this.gestations = []
      this.gestationInteractions = {}
      return db.collection('gestations')
        .where('patient', '==', db.doc('patients/' + this.$route.params.patientId))
        .get()
        .then(async query => {
          if (query.empty) {
            this.gestations = []
            this.gestationInteractions = {}
            return
          }
          this.gestations = query.docs.map(item => firestoreUtil.docToObject(item))
          this.gestations = this.gestations.sort((a, b) => b.date - a.date)
          await this.gestations.forEach(async gestation => {
            await db.collection('gestationInteraction')
              .where('gestation', '==', db.doc('gestations/' + gestation.iuid))
              .get()
              .then(async queryGI => {
                if (queryGI.empty) return
                if (!this.gestationInteractions[gestation.iuid]) this.gestationInteractions[gestation.iuid] = []
                queryGI.docs.forEach(item => {
                  this.gestationInteractions[gestation.iuid].push(firestoreUtil.docToObject(item))
                })
                this.gestationInteractions[gestation.iuid] = this.gestationInteractions[gestation.iuid].sort((a, b) => b.date - a.date)
                this.gestationInteractions = Object.assign({}, this.gestationInteractions)
              })
          })
        })
    },
    newGestation () {
      return db.collection('gestations').add({
        date: new Date(),
        company: db.doc('companies/' + this.company),
        patient: db.doc('patients/' + this.$route.params.patientId)
      }).then(data => {
        this.getGestation()
        return data
        // this.$router.push({ name: 'Ultra Fetal Gestation', params: { gestatinId: data.id } })
      })
    },
    gestationFormsBase: function (gi) {
      let formsBase
      if (this.currentGestation && this.currentGestation.formsBase && this.currentGestation.formsBase['gestationalAge.info.date']) {
        formsBase = this.currentGestation.formsBase
        formsBase['gestationalAge.info.calculada'] = moment().diff(formsBase['gestationalAge.info.date'].toDate(), 'days')
      } else {
        formsBase = {}
        formsBase['gestationalAge.info.calculo'] = 'desconhecido'
      }
      if (gi) {
        if (gi.forms && gi.forms['gestationalAge.info.accessionNumber']) {
          formsBase['gestationalAge.info.accessionNumber'] = gi.forms['gestationalAge.info.accessionNumber']
        } else if (gi.studies) {
          const keys = Object.keys(gi.studies)
          if (keys.length > 0) {
            formsBase['gestationalAge.info.accessionNumber'] = keys[0]
            for (let index = 0; index < keys.length; index++) {
              const key = keys[index]
              if (gi.studies[key].hasImage) {
                formsBase['gestationalAge.info.accessionNumber'] = keys[index]
                break
              }
            }
          }
        }
      } else {
        if (!this.currentGestation || !this.currentGestation.formsBase || !this.currentGestation.formsBase['gestationalAge.info.accessionNumber']) {
          formsBase['gestationalAge.info.accessionNumber'] = this.CompanyLastAn()
        }
      }
      return formsBase
    },

    CompanyLastAn () {
      var an
      if (!this.company.lastAn) {
        an = 1
        db.collection('companies').doc(this.company.iuid).set({lastAn: core.firestore.FieldValue.increment(1)}, {merge: true})
      } else {
        an = (this.company.lastAn + 1)
        db.collection('companies').doc(this.company.iuid).update({lastAn: core.firestore.FieldValue.increment(1)})
        var str = '' + (an)
        var pad = '00000'
        an = pad.substring(0, pad.length - str.length) + str
      }
      return an
    },

    deleteGestation (id) {
      this.alertConfirmRemove(() => {
        return db.collection('gestations').doc(id).delete().then(() => {
          this.getGestation()
          alert(this.$t('messages.successfullyRemoved'))
        }).catch(function (error) {
          this.getGestation()
          console.error('Error removing document: ', error)
        })
      })
    },
    deleteGestationInteraction (id, index) {
      this.alertConfirmRemove(() => {
        return db.collection('gestationInteraction').doc(id).delete().then(() => {
          if (index || index === 0) {
            const gestation = this.gestationsItems[index]
            if (gestation.interactions.length > 1) {
              if (gestation.interactions[0].iuid === id) {
                const formsBase = gestation.formsBase
                formsBase['gestationalAge.info.dateTest'] = gestation.interactions[1].date
                db.collection('gestations').doc(gestation.iuid).update({
                  formsBase: formsBase
                })
              }
            }
          }
          this.getGestation()
          alert(this.$t('messages.successfullyRemoved'))
        }).catch(function (error) {
          console.error('Error removing document: ', error)
        })
      })
    },
    getFormsList (forms) {
      if (!forms) return
      let result = []

      Object.entries(forms).forEach(([key, value]) => {
        const formatKey = key.split('.')[0]
        if (result.indexOf(formatKey) < 0) result.push(formatKey)
      })

      result = result.map(item => ['morphological', 'conclusion'].indexOf(item) > -1 ? this.$i18n.t(`words.${item}`) : this.$i18n.t(`messages.${item}`))

      return result
    },
    getGIwhitoutGestation () {
      this.unsubscribeGIwhitoutGestation = db.collection('gestationInteraction')
        .where('patient.id', '==', this.$route.params.patientId)
        .onSnapshot(query => {
          if (query.empty) return

          const data = query.docs
            .map(item => firestoreUtil.docToObject(item))
            .filter(item => !item.gestation)
            .sort((a, b) => b.date - a.date)
          this.listGiWhithoutGestation = data
        })
    },
    async newGestationInteraction (gestationIuid) {
      if (this.listGiWhithoutGestation.length > 0) {
        let date = new Date()
        date = date.toISOString().split('T')[0]
        if (this.listGiWhithoutGestation[0].studyDate && date === this.listGiWhithoutGestation[0].studyDate) {
          this.$swal.fire({
            type: 'info',
            title: 'Já existe um exame não vinculado, gostaria de vincular ao caso corrente?',
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: 'SIM',
            cancelButtonText: 'NÃO'
          }).then(async (result) => {
            if (result.value) {
              await this.addGiInLastGestation(this.listGiWhithoutGestation[0])
            } else if (result.dismiss === 'cancel') {
              const formsBase = this.gestationFormsBase()
              const studyAn = formsBase['gestationalAge.info.accessionNumber']
              const studies = {[studyAn]: {'accessionNumber': formsBase['gestationalAge.info.accessionNumber'], 'title': 'EXAME', 'date': new Date()}}

              // Verificar se o usuário atual é médico
              const isDoctor = this.user && this.user.role === 'doctor'

              // Se não for médico, passar null como médico responsável
              const doctorToAssign = isDoctor ? this.user : null

              const data = await apiGestation.createGestationInteraction(this.patient, doctorToAssign, this.company, formsBase, studies, gestationIuid)
              apiGestation.updatePatientLastInteraction(this.patient.iuid)
              this.$router.push({ name: 'Ultra Fetal Gestation Interaction', params: { gestationInteractionId: data.id } })
            }
          })
        } else {
          const formsBase = this.gestationFormsBase()
          const studyAn = formsBase['gestationalAge.info.accessionNumber']
          const studies = {[studyAn]: {'accessionNumber': formsBase['gestationalAge.info.accessionNumber'], 'title': 'EXAME', 'date': new Date()}}

          // Verificar se o usuário atual é médico
          const isDoctor = this.user && this.user.role === 'doctor'

          // Se não for médico, passar null como médico responsável
          const doctorToAssign = isDoctor ? this.user : null

          const data = await apiGestation.createGestationInteraction(this.patient, doctorToAssign, this.company, formsBase, studies, gestationIuid)
          apiGestation.updatePatientLastInteraction(this.patient.iuid)
          this.$router.push({ name: 'Ultra Fetal Gestation Interaction', params: { gestationInteractionId: data.id } })
        }
      } else {
        const formsBase = this.gestationFormsBase()
        const studyAn = formsBase['gestationalAge.info.accessionNumber']
        const studies = {[studyAn]: {'accessionNumber': formsBase['gestationalAge.info.accessionNumber'], 'title': 'EXAME', 'date': new Date()}}

        // Verificar se o usuário atual é médico
        const isDoctor = this.user && this.user.role === 'doctor'

        // Se não for médico, passar null como médico responsável
        const doctorToAssign = isDoctor ? this.user : null

        const data = await apiGestation.createGestationInteraction(this.patient, doctorToAssign, this.company, formsBase, studies, gestationIuid)
        apiGestation.updatePatientLastInteraction(this.patient.iuid)
        this.$router.push({ name: 'Ultra Fetal Gestation Interaction', params: { gestationInteractionId: data.id } })
      }
    },
    async newGestationAndInteraction () {
      const gestation = await this.newGestation()
      this.newGestationInteraction(gestation.id)
    },
    async addGiInNewGestation (gi) {
      const gestation = await this.newGestation()
      await apiGestation.saveGestationInteraction(gi.iuid, gestation.id, this.patient, this.user, this.company, this.gestationFormsBase(gi))
      setTimeout(() => {
        this.getGestation()
      }, 1000)
    },
    addGiInLastGestation (gi) {
      apiGestation.saveGestationInteraction(gi.iuid, this.currentGestation.iuid, this.patient, this.user, this.company, this.gestationFormsBase(gi))
      this.getGestation()
    },
    async resend (gi) {
      // console.log('gi', gi)
      if (!gi.forms || !gi.forms['gestationalAge.info.accessionNumber']) {
        alert('Não é possível publicar exames sem Código de exame (AN). Favor preencher no formulário "Informações"')
        return
      }
      if (!gi.patient || !gi.patient.patId) {
        alert('Não é possível publicar exames sem Código (PatId) de paciente. Favor preencher no cadastro do Paciente')
        return
      }
      await apiGestation.update({
        iuid: gi.iuid,
        status: 'PUBLICADO'
      })
      this.getGestation()
    },
    openReport (iuid) {
      window.open(URL_BASE_REPORT + iuid, '_blank')
    },
    openCase (index) {
      if (this.showCases[index]) {
        this.$set(this.showCases, index, false)
      } else {
        this.$set(this.showCases, index, true)
      }
    },
    openGestationInteraction (gi) {
      const routerNext = async () => {
        // Verificar se o usuário é médico e o exame não tem médico associado
        if (this.user.role === roleTypes.doctor && !gi.doctor) {
          try {
            // Atualizar o exame para associar o médico atual
            await db.collection('gestationInteraction').doc(gi.iuid).update({
              doctor: {
                id: this.user.uid,
                name: this.user.displayName,
                avatar: this.user.photoURL || null
              },
              resource: this.user.displayName
            })

            // Atualizar o objeto local para refletir a mudança
            gi.doctor = {
              id: this.user.uid,
              name: this.user.displayName,
              avatar: this.user.photoURL || null
            }
            gi.resource = this.user.displayName
          } catch (error) {
            console.error('Erro ao associar médico ao exame:', error)
          }
        }

        // Navegar para a página do exame
        this.$router.push({
          name: 'Ultra Fetal Gestation Interaction',
          params: {
            gestationInteractionId: gi.iuid
          }
        })
      }

      if (gi.status === reportStatusType.publicado) {
        if (!this.company || !this.company.security || !this.company.security.totpEnabled) {
          routerNext()
          return
        }

        return this.$swal.fire({
          title: 'Verificação de Segurança',
          text: 'Para editar um laudo publicado, digite o código de autenticação de dois fatores',
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off',
            placeholder: 'Código de 6 dígitos'
          },
          showCancelButton: true,
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          showLoaderOnConfirm: true,
          preConfirm: async (code) => {
            try {
              // Aqui você deve implementar a chamada para verificar o código TOTP
              const isValid = await this.verifyTOTP(code)
              if (!isValid) {
                throw new Error('Código inválido')
              }
              return true
            } catch (error) {
              this.$swal.showValidationMessage(error.message)
            }
          },
          allowOutsideClick: () => !this.$swal.isLoading()
        }).then((result) => {
          if (result.value) {
            routerNext()
          }
        })
      }

      routerNext()
    },
    async verifyTOTP (code) {
      try {
        const response = await api.post('/verifyTOTP', {
          code,
          userId: this.user.uid
        })
        return response.data.valid
      } catch (error) {
        console.error('Erro ao verificar TOTP:', error)
        throw new Error('Erro ao verificar o código')
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/ultra-fetal/Gestations.vue